import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, VRules, VConditions } from '../../../components'
import { Rules, PaymentConfirm, Currencies, TransferOptionUrl } from '../../../components/Payment';
import { Tooltip } from 'reactstrap';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { PaymentService } from '../../../services/PaymentService';
import { WithdrawalService } from '../../../services/WithdrawalService';


export class TPayTRC20Withdrawal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            confirm: false,
            tooltipAvailableMargin: false,
            success: false,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            acceptedCurrencies: [],
            availableMargin: 0,
            accountCurrency: "",
            commissionFee:0,
            // Payment Form
            login: 0,
            amount: 0,
            address: "",
            currency: "",
            usdtPrice: {
                price: 0,
                date: '',
                checkSum: '',
                symbol: '',
            },
            usdtAmount: 0,
            validation: {
                error: false,
                message: ""
            }
        }

    }
    componentWillMount() {

        TransferOptionService.Withdrawal.OptionPage(TransferOptionUrl()).then(response => {
            
            if (!response) {
                document.location.href = "/withdrawal";
                return false;
            }


            this.setState({
                paymentOptions: response,
                error: false
            })
        });
    }
    changeAccount(userAccount) {

        this.setState({ loading: true }, () => {

            PaymentService.CoinPrice({ 'Symbol': userAccount.info.currency, 'CoinCurrency': 'USDT' }).then(response => {
                this.setState({
                    usdtPrice: response,
                    loading: false,
                    login: userAccount.active,
                    availableMargin: userAccount.info.availableMargin.toFixed(2),
                    accountCurrency: userAccount.info.currency,
                    acceptedCurrencies: [userAccount.info.currency],
                    currency: userAccount.info.currency,
                    amount: 0,
                    usdtAmount: 0,
                    commissionFee:userAccount.info.commissionFee
                })
            });


        });

    }
    onChangeForm(e, key) {

        let value = e.target.value;

        if (key === "amount") {
            if (parseFloat(value) > this.state.availableMargin) {
                value = this.state.availableMargin;
            }
            let calculatedAmount = (value / this.state.usdtPrice.price).toFixed(4);
            this.setState({ usdtAmount: calculatedAmount });

        }

        this.setState({
            [key]: value
        });

    }
    onAvailableMargin() {

        let calculatedAmount = (this.state.availableMargin / this.state.usdtPrice.price).toFixed(8);

        this.setState({
            amount: this.state.availableMargin,
            usdtAmount: calculatedAmount
        });
    }
    onToggleWithdrawal() {
        if (this.isValid()) {
            this.setState(prevState => ({
                confirm: !prevState.confirm
            }));
        }
    }

    isValid() {
        VRules["address"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Address can not be empty.")
        }


        if (!this.state.confirm) {

            let error = Validator.Valid({ amount: this.state.amount, address: this.state.address }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;

    }

    onConfirmWithdrawal() {
        // Eğer miktar commissionFee'ye eşit veya daha küçükse, hata ver.
        if (this.state.amount <= this.state.commissionFee) {
            this.setState({
                validation: {
                    error: true,
                    message: Translate("Commission fee is insufficient. Please enter an amount greater than the commission fee.")
                }
            });
            return; // İşlemi sonlandır.
        }
        this.setState({
            loading: true,
            validation: {
                error: false,
                message: ""
            }
        }, () => {
            WithdrawalService.TPayTRC20({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.accountCurrency,
                address: this.state.address,
                price: this.state.usdtPrice,
            }).then(response => {
                if (response) {
                    this.setState({
                        loading: false,
                        success: !response.error,
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                } else {
                    this.setState({ loading: false });
                }


            });

        });
        
    }   
    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Withdrawal")} SubUrl="/withdrawal" />
                        <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
                            <div className="row">
                                <div className="col-md-12">
                                    <Rules Items={this.state.paymentOptions.rules} />
                                </div>
                                <div className={"col-md-12 " + (this.state.validation.error ? "" : "d-none")}>
                                    <div className={"alert alert-danger alert-dismissible fade mb-0 show"} role="alert">
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <strong>{Translate("Error !")}</strong> {Translate(this.state.validation.message)}
                                    </div>
                                </div>
                                {!this.state.confirm ?
                                    <div className="col-md-12">
                                        <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                                        <div className="form-group row ml-3">
                                            <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                                            <div className="col-sm-5">
                                                <UserAccounts OnlyInfo Witdrawal className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-3">
                                            <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("USDT Address")}</label>
                                            <div className="col-sm-5">
                                                <input className="form-control" type="text" id="coinAddress" autoComplete="off" value={this.state.address} onChange={(e) => this.onChangeForm(e, "address")} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-3">
                                            <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                                            <div className="col-sm-5">
                                                <div className="input-group">
                                                    <input className="form-control" type="number" id="amount" value={this.state.amount} autoComplete="off" onChange={(e) => this.onChangeForm(e, "amount")} onFocus={e => e.target.select()} />
                                                    <div className="input-group-append hide">
                                                        <button className="input-group-text pt-0 pb-0 bg-white" id="availableMargin" onClick={(e) => this.onAvailableMargin()}>
                                                            {this.state.availableMargin + " " + this.state.accountCurrency}
                                                        </button>
                                                        <Tooltip placement="right" isOpen={this.state.tooltipAvailableMargin} target="availableMargin" toggle={() => this.setState({ tooltipAvailableMargin: !this.state.tooltipAvailableMargin })}>
                                                            {Translate("Available Margin")}
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </div>                                            
                                        </div>                                   
                                        <div className="form-group row ml-3">
                                            <div className="col-sm-2 col-form-label">
                                                <strong>{Translate("")}</strong>
                                            </div>
                                            <div className="col-sm-5">
                                                <span>Commission Fee  {this.state.commissionFee} USD</span>
                                            </div>
                                        </div>

                                        <div className="form-group row ml-3">
                                            <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Approximate USDT Price")}</label>
                                            <div className="col-sm-5">
                                                <input className="form-control" type="text" id="usdtPrice" autoComplete="off" value={this.state.usdtPrice.price !== (0 || undefined) ? this.state.usdtPrice.price.toFixed(4) : 0 + " " + this.state.currency} readOnly />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-3">
                                            <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("USDT Amount")}</label>
                                            <div className="col-sm-5">
                                                <input className="form-control" type="text" id="usdtAmount" autoComplete="off" value={Math.max(0, this.state.usdtAmount - this.state.commissionFee) + " USDT"}  readOnly />
                                            </div>
                                        </div>                                       
                                        <div className="form-group row ml-3">
                                            <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                                            <div className="col-sm-5">
                                                <Currencies Items={[this.state.currency]} id="currency" onChange={(e) => this.onChangeForm(e, "currency")} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-3">
                                            <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                                            <div className="col-sm-5">
                                                <button className="btn btn-lg btn-success" onClick={(e) => this.onToggleWithdrawal()}>{Translate("Create a Withdrawal Request")}</button>
                                            </div>
                                        </div>

                                    </div>
                                    :
                                    <PaymentConfirm Form={[
                                        {
                                            title: Translate("Account"),
                                            value: this.state.login
                                        },
                                        {
                                            title: Translate("Address"),
                                            value: this.state.address
                                        },
                                        {
                                            title: Translate("Approximate USDT Price"),
                                            value: this.state.usdtAmount + " USDT"
                                        },
                                        {
                                            title: Translate("Amount"),
                                            value: this.state.amount.format('c') + " " + this.state.currency
                                        },
                                        {
                                            title: Translate("Commission Fee"),
                                            value: this.state.commissionFee.format('c') + " " + this.state.currency
                                        },
                                        {
                                            title: Translate("Warning:"),
                                            value: <span className="text-warning">{Translate("In order to complete the USDT operation, you must approve the operation via the e-mail which has been posted to you.")}</span>
                                        }

                                    ]} Cancel={(e) => this.onToggleWithdrawal()} Confirm={(e) => this.onConfirmWithdrawal()} Success={this.state.success} CancelButtonTitle={Translate('Cancel Withdrawal')} ConfirmButtonTitle={Translate('Confirm Withdrawal')} />
                                }
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}